export default __webpack_public_path__ + "static/media/img-0065-uk-full-face.4dfce337.png";